import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import useAgbState from '@/state/agbState';


export default /*#__PURE__*/_defineComponent({
  __name: 'Agb',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const { showAgbPopup } = useAgbState();

onMounted(async () => {
  try {
    await showAgbPopup();
    await nextTick();
  } catch (error) {
    // Error determining if AGB popup should be shown so we let the user proceed
  } finally {
    const redirectTo = route.query.redirectTo as string || '/';
    router.replace(redirectTo);
  }
});

return { __sfc: true,router, route, showAgbPopup }
}

})